module.exports = __webpack_public_path__ + "static/media/9.7f8426ae.JPG";